import { Capacitor } from '@capacitor/core'
import { initializeApp } from 'firebase/app'
import {
  connectAuthEmulator,
  browserLocalPersistence,
  getAuth,
  GoogleAuthProvider,
  initializeAuth,
  OAuthProvider,
} from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ??
    'AIzaSyDmX6_dfzvzJZ8r9uGUBQe5hIuH1Mlj374',
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'voxnela.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'voxnela',
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ??
    'voxnela.firebasestorage.app',
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '293273262415',
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ??
    '1:293273262415:web:b87aae749c71ae73e6cd3a',
  measurementId:
    import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? 'G-NYFC4C80QM',
}

export const firebaseApp = initializeApp(firebaseConfig)
// Keep the Web SDK session in WKWebView's persistent local storage. This also
// preserves email-code sessions, which do not create a native Firebase session.
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(firebaseApp, { persistence: browserLocalPersistence })
  : getAuth(firebaseApp)
export const db = getFirestore(firebaseApp)
export const storage = getStorage(firebaseApp)
export const functions = getFunctions(
  firebaseApp,
  import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION ?? 'us-central1',
)

export const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({ prompt: 'select_account' })
export const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')

const useEmulators =
  import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true'

if (useEmulators && !Capacitor.isNativePlatform()) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', {
    disableWarnings: true,
  })
  connectFirestoreEmulator(db, '127.0.0.1', 8080)
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
}

export const isPublicLaunch =
  String(import.meta.env.VITE_PUBLIC_LAUNCH).toLowerCase() === 'true'
